import moment from 'moment';

export const getEndDateBasedStartAndQty = (
  authStartDate,
  daysAuthorisedQty, 
  delay=0
) => {
  //console.log('### authStartDate')
  //console.log(authStartDate.split('T')[0])
  //console.log('### daysAuthorisedQty')
  //console.log(daysAuthorisedQty)
  let totalDaysAuthorisedEndDate =
    !authStartDate || !daysAuthorisedQty ? null : new Date(authStartDate.split('T')[0]);

  //console.log('### totalDaysAuthorisedEndDate')
  //console.log(totalDaysAuthorisedEndDate)

  return totalDaysAuthorisedEndDate === null
    ? null
    : totalDaysAuthorisedEndDate.setDate(
        totalDaysAuthorisedEndDate.getDate() + daysAuthorisedQty + delay
      );
};

export const getOverallQty = (daysAuthorisedQty, ext1DayQty, ext2DayQty, isResidential, delay=0) => {
  //console.log(isResidential);
  return !daysAuthorisedQty ? null : daysAuthorisedQty + (delay ? delay : 0) + (isResidential ? 1 : 0); //+ ext1DayQty + ext2DayQty;
};

export const getOverallEndDate = (
  authStartDate,
  daysAuthorisedQty,
  isResidential,
  delay=0
  //ext1DayQty,
  //ext2DayQty
) => {
  //console.log(authStartDate);
  //console.log(daysAuthorisedQty);
  //console.log(isResidential);
  if (authStartDate && daysAuthorisedQty) {
    let overallEndDate = new Date(authStartDate.split('T')[0]);
    return overallEndDate.setDate(
      overallEndDate.getDate() + daysAuthorisedQty + (delay ? delay : 0) + (isResidential ? 1 : 0) // + ext1DayQty + ext2DayQty
    );
  }
  else
    return null;  
};

export const getQtyBasedEndStartDate = (startDate, endDate) => {
  if (startDate && endDate) {
    const dateStarted = moment(startDate);
    const dateEnded = moment(endDate);
    const diff = dateEnded.diff(dateStarted);
    const noOfDays = moment.duration(diff);
    return Math.round(noOfDays.as('days')) + 1;
  }
  else
    return '';  
};

export const setUnits = (state) => {
  if (state.modality && state.daysAuthorisedQty) {
    state.maxUnitsPerWeek = state.modality.isResidential ? 7 : 3;
    state.maxIndsPerWeek = state.modality.isResidential ? 7 : 1;
    state.maxGrpsPerWeek = state.modality.isResidential ? 0 : 2;
    state.unitsTotal = Math.round((state.daysAuthorisedQty / 7) * state.maxUnitsPerWeek)
  }  
};
